import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { ReactNode } from 'react';
import { Route } from 'react-router-dom';
import { BikeleasingEmployeeInformationProvider } from '../../module/benefits/bikeleasing/context';
import { BikeleasingIntegrationsPage } from '../../page/bikeleasing/BikeleasingConnectionsPage';
import BikeleasingContractDetailsPage from '../../page/bikeleasing/BikeleasingContractDetailsPage';
import BikeleasingContractsPage from '../../page/bikeleasing/BikeleasingContractsPage';
import { BikeleasingEmployeesPage } from '../../page/bikeleasing/BikeleasingEmployeesPage';
import { RoutesExtensionInterface } from '../interface/routes.extension.interface';

export class BikeleasingRoutesExtension extends RoutesExtensionInterface {
  get privateRoutes(): ReactNode {
    const benefit = BenefitDTOBenefitEnum.Bikeleasing.toLowerCase();

    return (
      <>
        <Route
          path={`/benefits/${benefit}`}
          element={
            <BikeleasingEmployeeInformationProvider>
              <BikeleasingEmployeesPage />
            </BikeleasingEmployeeInformationProvider>
          }
        />
        <Route path={`/benefits/${benefit}/contracts`} element={<BikeleasingContractsPage />} />
        <Route path={`/benefits/${benefit}/integration`} element={<BikeleasingIntegrationsPage />} />
        <Route path={`/benefits/${benefit}/employee/:employeeId/contracts/:contractId`} element={<BikeleasingContractDetailsPage />} />
      </>
    );
  }
}
